import { useEffect, useReducer, useState } from 'react'

import { useIntl } from 'react-intl'
import { FileUpload } from '../../../widgets/components/FileUpload'
import { Quill } from '../../../widgets/components/Input/Quill'
import { ToolTipUI } from '../../../widgets/components/UI/ToolTipUI'
import '../../styles/InvestorUpdates.scss'
import { AddInvestorUpdateModal } from '../../views/AddInvestorUpdateModal'
import { AddInsertPitchDeskModal } from '../../views/AddInsertPitchDeskModal'
import { useAuth } from '../../../auth'
import { getBccTrackingData, getMailInfo } from '../../../profile/core/_requests'
import { DropdownType } from '../../../../core/_models'
import { SelectInput } from '../../../widgets/components/Input/SelectInput'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { getAllTemplate, getSingleTemplate } from '../../core/_request'
import { toast } from 'react-toastify'
import { Spinner } from '../../../widgets/components/General/Spinner'
/* eslint-disable react-hooks/exhaustive-deps */

const EmailTemplate = ({
  formik,
  quillText,
  setQuillText,
  emailSignature,
  setEmailSignature,
  storeFileIds,
  setStoreFileIds,
  setFooter,
  footer,
  templateData,
  setTemplateData,
  emailData,
}: {
  formik: any
  quillText: any
  setQuillText: any
  emailSignature: string
  setEmailSignature: any
  storeFileIds: any
  setStoreFileIds: any
  setFooter: any
  footer: any
  templateData: any
  setTemplateData: any
  emailData: any
}) => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [bccMail, setBccMail] = useState<string>('')
  const { currentUser } = useAuth()
  const [loading, setLoading] = useState<boolean>(true)
  const [, forceUpdate] = useReducer((x) => x + 1, 0)

  const [addInvestorUpdateModalShow, setAddInvestorUpdateModalShow] = useState(false)
  const [addInsertPitchDeskModalShow, setAddInsertPitchDeskModalShow] = useState(false)
  const [senderEmails, setSenderEmails] = useState<any[]>([])
  const [allTemplateData, setAllTemplateData] = useState<any>([])
  const handleAddInvestorUpdateModal = () => {
    setAddInvestorUpdateModalShow(true)
  }
  const handlePitchDeskModal = () => {
    setAddInsertPitchDeskModalShow(true)
  }
  const handleRemoveClick = (id: string) => {
    const updatedFileIds = storeFileIds.filter((file: any) => file.fileId !== id)
    setStoreFileIds(updatedFileIds)
  }

  useEffect(() => {
    const fetchBCCDetails = async (buttonClick?: boolean) => {
      const {
        data: { success, data },
      } = await getBccTrackingData(companyId)
      if (success) {
        setBccMail(data.email)
      }
    }
    if (companyId) {
      fetchBCCDetails()
    }
  }, [companyId])

  useEffect(() => {
    let senderEmailData: DropdownType[] = []
    if (currentUser) {
      let currentusers = [currentUser]
      senderEmailData = currentusers.map((curr: any) => {
        return {
          id: curr.userId,
          name: `${curr.email} `,
          value: `${curr.email}`,
        }
      })
      setSenderEmails([...senderEmailData])
    }
  }, [currentUser])

  const handleOpen = () => {
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }
  useEffect(() => {
    if (emailData && companyId && emailData.email.status === 'DRAFT') {
      formik.setFieldValue('subject', emailData.email.subject)
      formik.setFieldValue('quillText', emailData.email.body)
      if (emailData.email.pitchDeckId) {
        formik.setFieldValue('pitchDeckId', emailData.email.pitchDeckId)
      }
      if (emailData.email.updateId) {
        formik.setFieldValue('updateId', emailData.email.updateId)
      }
      if (emailData.email?.bccRequired) {
        formik.setFieldValue('bccEmail', bccMail)
      }
      setLoading(false)
    }
  }, [emailData])

  const getAllTemplates = async () => {
    if (companyId) {
      try {
        const {
          data: {
            data: { data },
            success,
            errors,
          },
        } = await getAllTemplate(+companyId, null, null, undefined, 'PUBLISHED')
        if (success) {
          const updatedTemplateData = data.map((template: any) => {
            return {
              id: template.templateId,
              name: `${template.name} `,
              value: `${template.templateId}`,
            }
          })
          if (!emailData) {
            setLoading(false)
          }

          setAllTemplateData(updatedTemplateData)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    getAllTemplates()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getSingleTemplateData = async (templateId: any) => {
    try {
      const {
        data: { data, success, errors },
      } = await getSingleTemplate(templateId)
      if (success) {
        setTemplateData(data)
        formik.setFieldValue('subject', data.subject)
        formik.setFieldValue('quillText', data.body)
        formik.setFieldValue('pitchDeckId', data.pitchDeckId)
        formik.setFieldValue('updateId', data.updateId)

        if (!!data.footer) {
          setFooter(true)
          setEmailSignature(data.footer)
        } else {
          setFooter(false)
        }
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formik.values?.selectTemplate) {
      getSingleTemplateData(formik.values.selectTemplate)
    }
  }, [formik.values.selectTemplate])
  useEffect(() => {
    if (templateData?.files?.length > 0) {
      setStoreFileIds(templateData?.files)
    }
  }, [templateData?.files?.length]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      {loading ? <Spinner /> : null}
      <form className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'>
        <div className='col-12 row mx-0'>
          <div className='col-6 px-2 mx-0'>
            <SelectInput
              label={formatMessage({ id: 'Select Template' })}
              fieldName={'selectTemplate'}
              placeholder={formatMessage({ id: 'Select Template' })}
              formik={formik}
              toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.ACTIVITY.SELECT_TEMPLATE' })}
              options={allTemplateData}
              width={12}
              margin={'me-0'}
              isStarRequired={true}
              disabled={!allTemplateData.length}
            />
          </div>
          <div className='col-6'>
            <SelectInput
              label={formatMessage({ id: 'Select Email' })}
              fieldName={'senderEmail'}
              placeholder={formatMessage({ id: 'Select Email' })}
              formik={formik}
              toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.ACTIVITY.SELECT_EMAIL' })}
              options={senderEmails}
              width={12}
              margin={'me-0'}
            />
          </div>
          <div className='col-12 mx-0'>
            <label className='form-label mt-4 font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
              {formatMessage({ id: 'Subject' })}*
              <ToolTipUI tooltipText={formatMessage({ id: 'GLOBAL.TOOLTIP.ACTIVITY.SUBJECT' })} />
            </label>
            <input
              type='text'
              className='form-control font-size-12 font-weight-400 '
              placeholder={formatMessage({ id: 'Subject' })}
              onChange={(e) => formik.setFieldValue('subject', e.target.value)}
              value={formik.values.subject}
            />
            <div className=' pt-2  mb-8'>
              <div className='col-6 d-flex justify-content-between'>
                {/* <p className='mb-0 text-white bg-gray-500 '>[[receiver_name]]</p> */}
                <p
                  className='mb-0 text-white bg-gray-500 cursor-pointer p-1 border-radius-box'
                  onClick={() =>
                    formik.setFieldValue(
                      'subject',
                      formik.values.subject + ' [[receiver_company_name]]'
                    )
                  }
                >
                  [[receiver_company_name]]
                </p>
                {/* <p className='mb-0 text-white bg-gray-500 '>[[update_period]]</p> */}
              </div>
              {formik.errors.subject ? (
                <div className='text-danger col-12  '>
                  {formatMessage({ id: formik.errors.subject })}
                </div>
              ) : null}
            </div>
          </div>
          <div className='col-12 mx-0'>
            <label className='form-label mt-4 font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
              {formatMessage({ id: 'Compose Email' })}
              <span>*</span>
              <ToolTipUI
                tooltipText={formatMessage({ id: 'GLOBAL.TOOLTIP.ACTIVITY.COMPOSE_EMAIL' })}
              />
            </label>
          </div>
          <div className='ql-container px-0 mx-2 compose-email-body'>
            <div className='w-100 h-30 ps-2 d-inline-flex border border-bottom-0 rounded-top border-gray-400'>
              <div className='d-flex justify-content-end col'>
                <div className='py-2'>
                  <button
                    type='button'
                    className={`mb-0 btn btn-color-primary py-0 ${!!formik.values?.bccEmail?.length && 'disableDiv'
                      }`}
                    onClick={() => {
                      formik.setFieldValue('bccEmail', bccMail)
                      toast.success(formatMessage({ id: 'BCC Successfully added' }))
                    }}
                  >
                    {formik.values?.bccEmail ? (
                      <p className='m-0 '>{formatMessage({ id: 'BCC address included.' })}</p>
                    ) : (
                      <p className='m-0'>{formatMessage({ id: 'Insert BCC mail' })}</p>
                    )}{' '}
                  </button>{' '}
                </div>
                <div className='py-2'>
                  <button
                    type='button'
                    className='mb-0 btn btn-color-primary py-0'
                    onClick={handlePitchDeskModal}
                  >
                    {formik.values.pitchDeckId
                      ? formatMessage({ id: 'Edit Pitch Deck' })
                      : formatMessage({ id: 'Insert Pitch Deck' })}{' '}
                  </button>{' '}
                </div>
                <div className='pe-1 py-2'>
                  <button
                    type='button'
                    className='mb-0 btn btn-color-primary py-0'
                    onClick={handleAddInvestorUpdateModal}
                  >
                    {formik.values.updateId
                      ? formatMessage({ id: 'Edit Updates' })
                      : formatMessage({ id: 'Insert Updates' })}{' '}
                  </button>{' '}
                </div>
              </div>
            </div>
            <Quill
              quillText={quillText}
              formik={formik}
              setQuillText={setQuillText}
              templateData={templateData}
              emailData={emailData}
            />
          </div>

          {footer ? (
            <div
              className='bg-gray-200 border border-top-0 mx-2 py-2 border-gray-400 content'
              dangerouslySetInnerHTML={{ __html: emailSignature }}
            ></div>
          ) : (
            <></>
          )}
          {formik.errors.quillText ? (
            <div className='text-danger col-12  '>
              {formatMessage({ id: formik.errors.quillText })}
            </div>
          ) : null}
          <div className='pt-8 pb-3 px-2 col-12'>
            <label> {formatMessage({ id: 'Attach files' })}</label>
            <div className='d-flex flex-md-column flex-row justify-content-between'>
              <button
                type='button'
                className='btn btn-primary w-150px font-size-13 height-36 d-flex align-items-center justify-content-center'
                onClick={handleOpen}
              >
                {formatMessage({ id: 'Import Files' })}{' '}
              </button>{' '}
            </div>

            <FileUpload
              fileSize={10485760}
              maxFileNumber={1}
              allowType={[
                'image/*',
                '.jpg',
                '.jpeg',
                '.png',
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
              ]}
              metaData={{ module: 'doc+img', isProtected: true, companyId: companyId }}
              modalStatus={modelStatus}
              handleClose={handleClose}
              handleSuccess={(fileId: number, name: string) => {
                const newFile = { fileId, name }
                setStoreFileIds((prevFileIds: any) => [...prevFileIds, newFile])
              }}
              resourceType='all'
            />
          </div>
          <div className='mt-5 d-flex gap-8 flex-wrap'>
            {formik.values?.bccEmail && (
              <div className='d-flex gap-3 align-items-center'>
                <div className='d-flex gap-0 align-items-center'>
                  <p className='m-0'>{formik.values?.bccEmail}</p>
                </div>
                <img
                  onClick={() => {
                    delete formik.values.bccEmail
                    forceUpdate()
                  }}
                  src={toAbsoluteUrl('/media/icons/investor-updates/deleteRed.svg')}
                  alt='garbage icon'
                  className='cursor-pointer'
                />
              </div>
            )}
            {formik.values?.pitchDeckId && (
              <div className='d-flex gap-3 align-items-center'>
                <div className='d-flex gap-0 align-items-center'>
                  <div>
                    <img
                      alt=''
                      className='w-25px me-3'
                      src={toAbsoluteUrl('/media/icons/file_extensions/pdf.svg')}
                    />
                  </div>
                  <p className='m-0'>{formatMessage({ id: 'Pitch Deck Attached' })}</p>
                </div>
                <img
                  onClick={() => {
                    delete formik.values.pitchDeckId
                    forceUpdate()
                  }}
                  src={toAbsoluteUrl('/media/icons/investor-updates/deleteRed.svg')}
                  alt='garbage icon'
                  className='cursor-pointer'
                />
              </div>
            )}
            {formik.values?.updateId && (
              <div className='d-flex gap-3 align-items-center'>
                <div className='d-flex gap-0 align-items-center'>
                  <div>
                    <img
                      alt=''
                      className='w-25px me-3'
                      src={toAbsoluteUrl('/media/icons/file_extensions/pdf.svg')}
                    />
                  </div>
                  <p className='m-0'>{formatMessage({ id: 'Investor Update Attached' })}</p>
                </div>
                <img
                  onClick={() => {
                    delete formik.values.updateId
                    forceUpdate()
                  }}
                  src={toAbsoluteUrl('/media/icons/investor-updates/deleteRed.svg')}
                  alt='garbage icon'
                  className='cursor-pointer'
                />
              </div>
            )}
            {storeFileIds?.length > 0 &&
              storeFileIds?.map((file: any) => (
                <div key={file?.id} className='d-flex gap-3 align-items-center'>
                  <div className='d-flex gap-0 align-items-center'>
                    <div>
                      {file && file?.name.split('.').pop() === 'pdf' ? (
                        <img
                          alt=''
                          className='w-25px me-3'
                          src={toAbsoluteUrl('/media/icons/file_extensions/pdf.svg')}
                        />
                      ) : (
                        <img
                          alt=''
                          className='w-50px me-3'
                          src={toAbsoluteUrl('/media/svg/files/blank-image.svg')}
                        />
                      )}
                    </div>
                    <p className='m-0'>{`${file?.name.substring(0, 25)}${file?.name.length > 25 ? '...' : ''
                      }`}</p>
                  </div>
                  <img
                    onClick={() => handleRemoveClick(file?.fileId)}
                    src={toAbsoluteUrl('/media/icons/investor-updates/deleteRed.svg')}
                    alt='garbage icon'
                    className='cursor-pointer'
                  />
                </div>
              ))}
          </div>
          <div className='mt-8 d-flex align-items-center px-2'>
            <input
              className=''
              type='checkbox'
              checked={footer}
              onChange={async (e) => {
                if (e.target.checked && currentUser) {
                  setFooter(true)
                  const {
                    data: { success, data },
                  } = await getMailInfo(companyId)
                  if (success) {
                    setEmailSignature(data.emailSignature)
                  }
                } else {
                  setFooter(false)
                  setEmailSignature(null)
                }
              }}
            />{' '}
            <label className='ps-3 '>{formatMessage({ id: 'Add footer' })}</label>{' '}
            <ToolTipUI
              tooltipText={formatMessage({
                id: 'GLOBAL.TOOLTIP.EMAIL_TEMPLATE.FOOTER',
              })}
            />
          </div>
          {/* end::Form group */}
          <AddInvestorUpdateModal
            addInvestorUpdateModalShow={addInvestorUpdateModalShow}
            setAddInvestorUpdateModalShow={setAddInvestorUpdateModalShow}
            formik={formik}
          />
          <AddInsertPitchDeskModal
            addInsertPitchDeskModalShow={addInsertPitchDeskModalShow}
            setAddInsertPitchDeskModalShow={setAddInsertPitchDeskModalShow}
            formik={formik}
          />
        </div>
      </form>
    </>
  )
}

export default EmailTemplate
